module.exports = {"bewizr-agenda":{"empty":{"title":"Sin actividades","detail":"No tienes actividades programadas."}}}